import Cookies from "js-cookie";

export function readLocalStorage() {
  if (import.meta.client) {
    // Read values from local storage
    const prefix = localStorage.getItem("prefix");
    const firstName = localStorage.getItem("firstName");
    const lastName = localStorage.getItem("lastName");
    const street = localStorage.getItem("street");
    const postcode = localStorage.getItem("postcode");
    const city = localStorage.getItem("city");

    // Create an object with the retrieved values
    return {
      prefix: prefix,
      firstName: firstName,
      lastName: lastName,
      street: street,
      postcode: postcode,
      city: city,
    };
  }
  return {};
}

export function getSortedOrders(orders: any) {
  if (orders && orders.length > 0) {
    orders.sort((a: any, b: any) => b.orderNumber - a.orderNumber);
  }
  return orders;
}

export function removeProductById(productId: any, products: any) {
  for (let i = 0; i < products.length; i++) {
    if (products[i].id === productId) {
      products.splice(i, 1);
      break; // Exit the loop after removing the product
    }
  }

  return products;
}

export async function recreateCart() {
  const storedPersonData = localStorage.getItem("unPaidCart");
  if (typeof storedPersonData === "string") {
    const cartItems = JSON.parse(storedPersonData);

    for (const item of cartItems) {
      // Skip items that have a bundle payload
      const payload = item.payload as { bundle?: any } & Record<string, any>;
      if (payload?.bundle) {
        continue;
      }

      const { addToCart, isInCart, quantity } = useAddToCart(item);
      quantity.value = item.quantity;
      if (!isInCart.value) {
        await addToCart();
      }
    }
  }
}

export function rearrangeArray(array: any) {
  // Move '2nd image' (index 1) to the start
  array.splice(0, 0, array.splice(1, 1)[0]);

  if (array.length === 3) {
    // Move 'Third image' (index 2) to the second position
    array.splice(1, 0, array.splice(2, 1)[0]);
  }

  return array;
}

// Function to escape regular expression characters in sanitized words
function escapeRegExp(string: any) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

export function combineData(propertyGroups: any, propertyGroupOptions: any) {
  const combinedData = {};

  for (const group of propertyGroups) {
    const groupId = group?.id;
    const groupName = group?.translated?.name;

    const matchedOptions = propertyGroupOptions.filter(
      (option) => option?.groupId === groupId
    );

    if (matchedOptions.length > 0) {
      combinedData[groupName] = matchedOptions
        .map((option) => option.translated.name)
        .join(", ");
    }
  }

  return combinedData;
}

export async function getProductBundles(product) {
  const runtimeConfig = useRuntimeConfig();

  const url =
    runtimeConfig.public.shopware.endpoint +
    `product/${product.id}/cross-selling`;

  const headers = {
    "Sw-access-key": runtimeConfig.public.shopware.accessToken,
    "Sw-Context-Token": Cookies.get("sw-context-token"),
    "sw-include-seo-urls": 1,
  };

  const requestBody = {};

  let crossSellings = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    body: JSON.stringify(requestBody),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((error) => {
      console.error("Error:", error);
    });

  const Bundels = crossSellings.filter(
    (item) => item?.crossSelling?.position === 1
  );
  if (Bundels.length) {
    return Bundels[0];
  }
  return null;
}
